import React from 'react'
import "./style.css";
import Services from '../../Components/Services/Services';
import HeaderText from '../../Components/HeaderText/HeaderText';
import Contact from '../Contact/Contact';
import OurWork from '../OurWork/OurWork';
import Product from '../Product/Product';
import Testimonials from '../../Components/Testimonials/Testimonials';
import SeoHead from '../../Components/SeoHead/SeoHead';
import fondo from '../../assets/images/fondo.webp';

function Home() {
    return (
        <>
            <SeoHead
                path="/"
                description="Marmolería Colaiacovo: más de 60 años de experiencia en mármoles, granitos y cuarzos en Flores, Buenos Aires. Atención personalizada e instalación profesional."
            />
            <div className="page-container">

                {/* Hero — full width of page container */}
                <div className="hero-wrapper">
                    <article id="home" className="background-container pt-10">
                        <img
                            src={fondo}
                            alt=""
                            aria-hidden="true"
                            fetchpriority="high"
                            decoding="sync"
                            className="hero-bg-img"
                        />
                        <HeaderText />
                    </article>
                    <div className="services-float">
                        <Services />
                    </div>
                </div>

                {/* Content sections — max-w-6xl centrado */}
                <div className="content-sections mx-auto max-w-6xl text-center">
                    <article id="contact" className="contact-container" style={{backgroundColor: 'transparent', paddingBottom: '200px'}}>
                        <Contact />
                    </article>

                    <article id="nuestrosTrabajos" style={{backgroundColor: 'transparent', paddingBottom: '200px'}}>
                        <OurWork />
                    </article>

                    <article id="product" style={{backgroundColor: 'transparent', paddingBottom: '200px'}}>
                        <Product />
                    </article>

                    <article id="testimonios" style={{paddingBottom: '60px'}}>
                        <Testimonials />
                    </article>
                </div>

            </div>
        </>
    );
}

export default Home;
